export function HTMLTrapFocus(container: string, initial: string, final: string) {
  const initialElement: HTMLElement | null = document.querySelector(initial);
  const finalElement: HTMLElement | null = document.querySelector(final);
  const containerElement: HTMLElement | null = document.querySelector(container);

  if (initialElement && finalElement && containerElement) {
    reset(containerElement);
    createPortal(containerElement, 'Start', initialElement, finalElement , containerElement);
    createPortal(containerElement, 'End', initialElement, finalElement , containerElement);
  } else 
    // eslint-disable-next-line no-console
    console.error('Components not found', initialElement, finalElement);
    
}

export function createPortal(target: Element, position: string, initialElement: HTMLElement, finalElement: HTMLElement , containerElement: HTMLElement) {
  const portal = document.createElement('div');
  portal.tabIndex = 0;
  portal.id = `htmlTrapFocusPortal${position}`;
  portal.onfocus = () => { transportFrom(position, initialElement, finalElement , containerElement); };
  if (position === 'Start')
    target.insertAdjacentElement('afterbegin', portal);
  else
    target.insertAdjacentElement('beforeend', portal);

}
export function transportFrom(position: string, initialElement: HTMLElement, finalElement: HTMLElement, containerElement: HTMLElement) {
  if (initialElement && finalElement && containerElement) 
    if (position === 'Start')
      finalElement.focus();
    else
      initialElement.focus();
  ;
}
export function reset(containerElement: HTMLElement) {
  if (containerElement) {
    const startPortal: HTMLElement | null = containerElement.querySelector('#htmlTrapFocusPortalStart');
    const endPortal: HTMLElement | null = containerElement.querySelector('#htmlTrapFocusPortalEnd');
    if (startPortal && endPortal) {
      const parentStartParent: HTMLElement | null = startPortal.parentElement;
      const endPortalParent : HTMLElement | null = endPortal.parentElement;
      if(parentStartParent && endPortalParent){
        parentStartParent.removeChild(startPortal);
        endPortalParent.removeChild(endPortal);
      }
    }
  }
}